module.exports = __webpack_public_path__ + "static/media/1.b7cea9e7.jpg";